// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   useGetNotificationsQuery,
//   useMarkNotificationAsReadMutation,
//   useMarkAllNotificationsAsReadMutation
// } from "../../store/api/notificationApi";
// import { formatLocalTime } from "../../utils/dateTime";
// import styles from "./NotificationDropdown.module.css";

// export default function NotificationDropdown() {

//   const navigate = useNavigate();

//   const [cursor, setCursor] = useState(null);
//   const [notifications, setNotifications] = useState([]);

//   const observer = useRef();

//   const {
//     data,
//     isLoading,
//     isFetching
//   } = useGetNotificationsQuery({
//     cursor,
//     pageSize: 10
//   });

//   const [markAsRead] = useMarkNotificationAsReadMutation();
//   const [markAllAsRead] = useMarkAllNotificationsAsReadMutation();
//   const handleMarkAllAsRead = async (e) => {
//     e.stopPropagation();
//     setNotifications(prev =>
//       prev.map(n => ({ ...n, isRead: true }))
//     );
//     try {
//       await markAllAsRead().unwrap();
//     } catch (err) {
//       console.error("Failed to mark all notifications as read", err);
//     }
//   };
  
//   const nextCursor = data?.nextCursor;

//   // append notifications
//   useEffect(() => {

//     if (!data?.notifications) return;
  
//     const filtered = data.notifications.filter(
//       n => n.type !== "Message"
//     );
  
//     setNotifications(prev => {
  
//       const incomingIds = filtered.map(n => n.id).join(",");
//       const existingIds = prev.map(n => n.id).join(",");
  
//       if (incomingIds === existingIds) {
//         return prev;
//       }
  
//       const merged = [...prev];
  
//       filtered.forEach(n => {
  
//         const index = merged.findIndex(x => x.id === n.id);
  
//         if (index !== -1) {
//           merged[index] = {
//             ...merged[index],
//             ...n
//           };
//         } else {
//           merged.push(n);
//         }
  
//       });
  
//       return merged;
  
//     });
  
//   }, [data]);

//   // infinite scroll
//   const lastNotificationRef = (node) => {

//     if (isFetching) return;

//     if (observer.current) observer.current.disconnect();

//     observer.current = new IntersectionObserver(entries => {

//       if (
//         entries[0].isIntersecting &&
//         nextCursor && cursor !== nextCursor
//       ) {
//         setCursor(nextCursor);
//       }

//     });

//     if (node) observer.current.observe(node);
//   };

//   const handleNotificationClick = (notification) => {

//   // ✅ 1. instant UI update (this replaces old RTK auto update)
//   if (!notification.isRead) {

//     setNotifications(prev =>
//       prev.map(n =>
//         n.id === notification.id
//           ? { ...n, isRead: true }
//           : n
//       )
//     );

//     markAsRead(notification.id);
//   }

//   // ✅ 3. navigation (UPDATED)
//   switch (notification.type) {

//     case 'ChatRequest':
//       navigate('/chat?request=true');
//       break;

//     case 'ChatRequestAccepted':
//         navigate('/chat'); // or your chat page route
//         break;

//     case 'Like':
//       if (notification.postId) {
//         navigate(`/post/${notification.postId}`);
//       }
//       break;

//     case 'Comment':
//       if (notification.postId) {
//         navigate(`/post/${notification.postId}`, {
//           state: { commentId: notification.commentId },
//         });
//       }
//       break;

//     case 'Share':
//         if (notification.postId) {
//           navigate(`/post/${notification.postId}`);
//         }
//         break;

//     case 'Follow':
//       if (notification.users?.[0]?.id) {
//         navigate(`/profile/${notification.users[0].id}`);
//       }
//       break;

//     default:
//       navigate('/home');
//   }
// };

//   if (isLoading) {
//     return (
//       <div className={styles.dropdown}>
//         Loading...
//       </div>
//     );
//   }

//   if (!notifications.length) {
//     return (
//       <div className={styles.dropdown}>
//         No notifications
//       </div>
//     );
//   }

//   return (

//     <div className={styles.dropdown}>
    
    
//       {notifications
//   .filter(n => n.type !== "Message").map((n, index) => {

//         const isLast =
//           index === notifications.length - 1;

//         return (

//           <div
//             key={n.id}
//             ref={isLast ? lastNotificationRef : null}
//             className={`${styles.item} ${!n.isRead ? styles.unread : ""}`}
//             onClick={() => handleNotificationClick(n)}
//           >

//             {n.users?.[0]?.profilePhotoUrl ? (
//               <img
//                 src={n.users[0].profilePhotoUrl}
//                 className={styles.avatar}
//                 alt=""
//               />
//             ) : (
//               <div className={styles.avatarPlaceholder}>
//                 {n.users?.[0]?.name?.charAt(0)?.toUpperCase() || "?"}
//               </div>
//             )}

//             <div className={styles.content}>
//               <p>{getNotificationText(n)}</p>
//               <span>{formatLocalTime(n.createdAt)}</span>
//             </div>

//             {!n.isRead &&
//               <div className={styles.unreadDot}></div>
//             }

//           </div>

//         );

//       })}

//       {isFetching && (
//         <p className={styles.loadingMore}>
//           Loading more...
//         </p>
//       )}
//        {notifications.some(n => !n.isRead) && (
//       <div className={styles.bottomBar}>
//         <button
//           className={styles.markAllBtn}
//           onClick={handleMarkAllAsRead}
//         >
//           Mark all as read
//         </button>
//       </div>
//     )}
//     </div>
//   );
// }

// function getNotificationText(notification) {

//   const users = notification.users || [];
// const firstUser = users[0] || notification.sender;
//   const others = notification.othersCount || 0;

//   if (!firstUser)
//     return "Someone interacted with your post";

//   if (notification.type === "Like") {

//     if (others > 0)
//       return `${firstUser.name} and ${others} others liked your post`;

//     return `${firstUser.name} liked your post`;
//   }

//   if (notification.type === "ChatRequest")
//     return `${firstUser.name} sent you a chat request`;

//   if (notification.type === "ChatRequestAccepted")
//     return `${firstUser.name} accepted your chat request`;

//   if (notification.type === "Comment") {

//     if (others > 0)
//       return `${firstUser.name} and ${others} others commented on your post`;

//     return `${firstUser.name} commented on your post`;
//   }

//   if (notification.type === "Follow")
//     return `${firstUser.name} started following you`;
  
//   if (notification.type === "Share")
//     return `${firstUser.name} shared your post`;
  
//   if (notification.type === "Message")
//     return `${firstUser.name} sent you a message`;

//   return `${firstUser.name} sent a notification`;
// }

 
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation
} from "../../store/api/notificationApi";
import { formatLocalTime } from "../../utils/dateTime";
import styles from "./NotificationDropdown.module.css";
 
// FIX: added Reply, LikeShared, CommentShared badges
const TYPE_META = {
  Like:                 { icon: "\u2764",   badge: styles.badgeLike },
  LikeShared:           { icon: "\u2764",   badge: styles.badgeLike },
  Comment:              { icon: "\uD83D\uDCAC", badge: styles.badgeComment },
  CommentShared:        { icon: "\uD83D\uDCAC", badge: styles.badgeComment },
  Reply:                { icon: "\u21A9",   badge: styles.badgeComment },
  Follow:               { icon: "+",        badge: styles.badgeFollow },
  Share:                { icon: "\u2197",   badge: styles.badgeShare },
  ChatRequest:          { icon: "\u2709",   badge: styles.badgeChat },
  ChatRequestAccepted:  { icon: "\u2713",   badge: styles.badgeChat },
  PostLocked:           { icon: "\uD83D\uDD12", badge: styles.badgeLocked },
  SharedPostRemoved:    { icon: "\uD83D\uDEAB", badge: styles.badgeRemoved },
};
 
function getTypeMeta(type) {
  return TYPE_META[type] || { icon: "\uD83D\uDD14", badge: styles.badgeDefault };
}
 
function getDayLabel(dateString) {
  if (!dateString) return "Earlier";
  const date = new Date(dateString);
  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
 
  if (date.toDateString() === now.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
 
  const daysAgo = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  if (daysAgo < 7) return "This week";
  return "Earlier";
}
 
export default function NotificationDropdown() {
  const navigate = useNavigate();
 
  const [cursor, setCursor] = useState(null);
  const [notifications, setNotifications] = useState([]);
 
  const observer = useRef();
 
  const { data, isLoading, isFetching } = useGetNotificationsQuery({
    cursor,
    pageSize: 8
  });
 
  const [markAsRead] = useMarkNotificationAsReadMutation();
  const [markAllAsRead] = useMarkAllNotificationsAsReadMutation();
 
  const handleMarkAllAsRead = async (e) => {
    e.stopPropagation();
    setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
    try {
      await markAllAsRead().unwrap();
    } catch (err) {
      console.error("Failed to mark all notifications as read", err);
    }
  };
 
  const nextCursor = data?.nextCursor;
 
  useEffect(() => {
    if (!data?.notifications) return;
 
    const filtered = data.notifications.filter(n => n.type !== "Message");
 
    setNotifications(prev => {
      const incomingIds = filtered.map(n => n.id).join(",");
      const existingIds = prev.map(n => n.id).join(",");
      if (incomingIds === existingIds) return prev;
 
      const merged = [...prev];
      filtered.forEach(n => {
        const index = merged.findIndex(x => x.id === n.id);
        if (index !== -1) merged[index] = { ...merged[index], ...n };
        else merged.push(n);
      });
      return merged;
    });
  }, [data]);
 
  const lastNotificationRef = (node) => {
    if (isFetching) return;
    if (observer.current) observer.current.disconnect();
 
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && nextCursor && cursor !== nextCursor) {
        setCursor(nextCursor);
      }
    });
 
    if (node) observer.current.observe(node);
  };
 
  // FIX: unified navigation that works for Like, Comment, Reply, Share variants
  // and routes with type=Post/SharedPost so the post page knows which to fetch.
  const handleNotificationClick = (notification) => {
    if (!notification.isRead) {
      setNotifications(prev =>
        prev.map(n => n.id === notification.id ? { ...n, isRead: true } : n)
      );
      markAsRead(notification.id);
    }
 
   // REPLACE the navigation switch in handleNotificationClick / handleClick with:
 
const postType = notification.postType || "Post";
const navigationId = notification.sharedPostId ?? notification.postId;
 
switch (notification.type) {
  case 'ChatRequest':
    navigate('/chat?request=true');
    break;
 
  case 'ChatRequestAccepted':
    navigate('/chat');
    break;
 
  case 'Like':
  case 'LikeShared':
    if (navigationId) {
      navigate(`/post/${navigationId}?type=${postType}`);
    }
    break;
 
  case 'Comment':
  case 'CommentShared':
    if (navigationId) {
      navigate(`/post/${navigationId}?type=${postType}`, {
        state: { commentId: notification.commentId },
      });
    }
    break;
 
  case 'Reply':
    if (navigationId) {
      navigate(`/post/${navigationId}?type=${postType}`, {
        state: { commentId: notification.commentId, isReply: true },
      });
    }
    break;
 
  case 'Share':
    if (notification.postId) {
      navigate(`/post/${notification.postId}?type=${postType}`);
    }
    break;
 
  case 'Follow':
    if (notification.users?.[0]?.id) {
      navigate(`/profile/${notification.users[0].id}`);
    }
    break;
 
  case 'PostLocked':
    if (notification.postId) navigate(`/post/${notification.postId}`);
    else navigate('/home');
    break;
 
  case 'SharedPostRemoved':
    navigate('/home');
    break;
 
  default:
    navigate('/home');
}
 };
 
if (isLoading) {
    return (
      <div className={styles.dropdown}>
        <div className={styles.dropdownHeader}>
          <h3 className={styles.dropdownTitle}>Notifications</h3>
        </div>
        <div className={styles.loading}>Loading...</div>
      </div>
    );
  }
 
  const visibleNotifications = notifications.filter(n => n.type !== "Message");
 
  if (!visibleNotifications.length) {
    return (
      <div className={styles.dropdown}>
        <div className={styles.dropdownHeader}>
          <h3 className={styles.dropdownTitle}>Notifications</h3>
        </div>
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>{"\uD83D\uDD14"}</div>
          You're all caught up!
        </div>
      </div>
    );
  }
 
  let lastDayLabel = null;
 
  return (
    <div className={styles.dropdown}>
      <div className={styles.dropdownHeader}>
        <h3 className={styles.dropdownTitle}>Notifications</h3>
      </div>
 
      {visibleNotifications
        .slice(0, 8)
      .map((n, index) => {
        const isLast = index === visibleNotifications.length - 1;
        const dayLabel = getDayLabel(n.createdAt);
        const showDayLabel = dayLabel !== lastDayLabel;
        lastDayLabel = dayLabel;
 
        const meta = getTypeMeta(n.type);
 
        return (
          <React.Fragment key={n.id}>
            {showDayLabel && <div className={styles.dayLabel}>{dayLabel}</div>}
 
            <div
              ref={isLast ? lastNotificationRef : null}
              className={`${styles.item} ${!n.isRead ? styles.unread : ""}`}
              onClick={() => handleNotificationClick(n)}
            >
              <div className={styles.avatarWrap}>
                {n.users?.[0]?.profilePhotoUrl ? (
                  <img
                    src={n.users[0].profilePhotoUrl}
                    className={styles.avatar}
                    alt=""
                  />
                ) : (
                  <div className={styles.avatarPlaceholder}>
                    {n.users?.[0]?.name?.charAt(0)?.toUpperCase() || "?"}
                  </div>
                )}
                <div className={`${styles.typeBadge} ${meta.badge}`}>
                  {meta.icon}
                </div>
              </div>
 
              <div className={styles.content}>
                <p dangerouslySetInnerHTML={{ __html: getNotificationText(n) }} />
                <span>{formatLocalTime(n.createdAt)}</span>
              </div>
 
              {!n.isRead && <div className={styles.unreadDot} />}
            </div>
          </React.Fragment>
        );
      })}
 
      {isFetching && (
        <p className={styles.loadingMore}>Loading more...</p>
      )}
 
      <div className={styles.bottomBar}>
        {notifications.some(n => !n.isRead) && (
          <button className={styles.markAllBtn} onClick={handleMarkAllAsRead}>
            Mark all as read
          </button>
        )}
        <button
          className={styles.seeAllBtn}
          onClick={() => navigate("/notifications")}
        >
          {visibleNotifications.length >= 8 ? "See All Notifications →" : "Open Notifications →"}
        </button>
      </div>
 
    </div>
  );
}
 
function getNotificationText(notification) {
  const users = notification.users || [];
  const firstUser = users[0] || notification.sender;
  const others = notification.othersCount || 0;
 
  if (notification.type === "PostLocked") {
    return notification.commentText
      || "Your post was hidden because it was reported by multiple users.";
  }
 
  if (notification.type === "SharedPostRemoved") {
    return notification.commentText
      || "Your shared post was removed because it was reported by multiple users.";
  }
 
  if (!firstUser) return "Someone interacted with your post";
 
  const name = `<strong>${firstUser.name}</strong>`;
 
  if (notification.type === "Like") {
    if (others > 0) return `${name} and <strong>${others} others</strong> liked your post`;
    return `${name} liked your post`;
  }
 
  // FIX: LikeShared - sent to the SHARER, not the original owner
  if (notification.type === "LikeShared") {
    if (others > 0) return `${name} and <strong>${others} others</strong> liked a post you shared`;
    return `${name} liked a post you shared`;
  }
 
  if (notification.type === "ChatRequest")
    return `${name} sent you a chat request`;
 
  if (notification.type === "ChatRequestAccepted")
    return `${name} accepted your chat request`;
 
  if (notification.type === "Comment") {
    if (others > 0) return `${name} and <strong>${others} others</strong> commented on your post`;
    return `${name} commented on your post`;
  }
 
  // FIX: CommentShared - sent to the SHARER, not the original owner
  if (notification.type === "CommentShared")
    return `${name} commented on a post you shared`;
 
  // FIX: Reply - was missing entirely, fell through to generic text before
  if (notification.type === "Reply")
    return `${name} replied to your comment`;
 
  if (notification.type === "Follow")
    return `${name} started following you`;
 
  if (notification.type === "Share")
    return `${name} shared your post`;
 
  if (notification.type === "Message")
    return `${name} sent you a message`;
 
  return `${name} sent a notification`;
}